export default __webpack_public_path__ + "static/media/selected-layout-grid.62384720.svg";